"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderActivityTime = exports.hasStarted = exports.isDayAfterTomorrow = exports.isTomorrow = exports.isToday = exports.getDates = void 0;
const helpers_1 = require("../../../common/helpers/helpers");
const getDates = () => {
    const today = new Date();
    const tomorrow = new Date(today);
    const dayAfterTomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);
    dayAfterTomorrow.setDate(today.getDate() + 2);
    return { today, tomorrow, dayAfterTomorrow };
};
exports.getDates = getDates;
const isToday = (dateString) => {
    const { today } = (0, exports.getDates)();
    const date = new Date(dateString);
    return (date.getDate() === today.getDate() &&
        date.getMonth() === today.getMonth() &&
        date.getFullYear() === today.getFullYear());
};
exports.isToday = isToday;
const isTomorrow = (dateString) => {
    const { tomorrow } = (0, exports.getDates)();
    const date = new Date(dateString);
    return (date.getDate() === tomorrow.getDate() &&
        date.getMonth() === tomorrow.getMonth() &&
        date.getFullYear() === tomorrow.getFullYear());
};
exports.isTomorrow = isTomorrow;
const isDayAfterTomorrow = (dateString) => {
    const { dayAfterTomorrow } = (0, exports.getDates)();
    const date = new Date(dateString);
    return (date.getDate() === dayAfterTomorrow.getDate() &&
        date.getMonth() === dayAfterTomorrow.getMonth() &&
        date.getFullYear() === dayAfterTomorrow.getFullYear());
};
exports.isDayAfterTomorrow = isDayAfterTomorrow;
const hasStarted = (dateString) => {
    const date = new Date(dateString);
    return date < new Date();
};
exports.hasStarted = hasStarted;
const renderActivityTime = (activity, timezone) => {
    if (!activity.start) {
        return null;
    }
    const startTime = helpers_1.Helpers.getHourFromDate(activity.start, timezone);
    const endTime = activity.end ? helpers_1.Helpers.getHourFromDate(activity.end, timezone) : '';
    if (!activity.end) {
        return `${startTime}`;
    }
    return `${startTime} - ${endTime}`;
};
exports.renderActivityTime = renderActivityTime;
